/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import { sentenceCase, capitalCase  } from 'change-case';
import { useState, useEffect, } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  Tabs,
  Button,
  Tab,
} from '@mui/material';

// format
import FormControlLabel from '@mui/material/FormControlLabel';
// routes
import {  PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';

import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// format number 
import { fCurrency,} from '../../utils/formatNumber';
// sections
import { TransHead, PlanToolbar } from '../../sections/admin/user/list';


// axios

import axios from '../../utils/axios'; 



// ----------------------------------------------------------------------

const TABLE_HEAD = [
 { id: 'referrence', label: 'Referrence', alignRight: false },
 { id: 'disco_name', label: 'Disco Name', alignRight: false },
  { id: 'meter_type', label: 'Meter Type', alignRight: false },
  { id: 'meter_number', label: 'Meter Number', alignRight: false },
  { id: 'customer_name', label: 'Customer Name', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'charges', label: 'charges', alignRight: false },
  { id: 'oldbal', label: 'Old Bal', alignRight: false },
  { id: 'newbal', label: 'New Bal', alignRight: false },
  { id: 'purchased_code', label: 'Purchased Code', alignRight: false },
  { id: 'system', label: 'System', alignRight: false },
  {id: 'date', label: 'Purchased Date', alignRight: false},
  { id: 'plan_status', label: 'Plan Status', alignRight: false },
  { id: 'invioce', label: 'INVIOCE', alignRight: false },
];
const ACCOUNT_TABS = [
    {
     value: 'ALL',
     label: 'ALL'
    },
    {
      value: 1,
      label: 'success'   
    },
    {
      value: 0,
     label: 'processing'
    },
    {
        value: 2,
        label: 'fail'
    }
  ];
// ----------------------------------------------------------------------

export default function BillTransaction() {
  const theme = useTheme();
  const { themeStretch } = useSettings();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
const [load,SetLoad] = useState(true);
const [totalPage, SetTotal] = useState(0);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, Setdense] = useState(false);
  const [isNotFound, SetNotFound] = useState(false);
  const [status, setStatus] = useState('ALL');
  const AccessToken =  window.localStorage.getItem('accessToken');

  useEffect(()  => {
    initialize(page,rowsPerPage,status,filterName);
}, []);

const initialize = async (pag,adex = 5,status,search) => {
let adex_page;
if(pag > page){
   adex_page = pag + 1;
}else{
   adex_page = pag;
}
SetLoad(true);

try{

const data =  await axios.get(`/api/system/all/trans/${AccessToken}/secure?page=${adex_page}&adex=${adex}&status=${status}&search=${search}&database_name=bill_trans`)
            
setUserList(data.data?.bill_trans?.data);
            SetTotal(data.data?.bill_trans?.total)
            SetLoad(false);       
            setPage(pag);
            SetNotFound(data.data?.bill_trans?.total === 0)
            
}catch(_){
  SetLoad(false);
      setUserList([]);
}

}     





 
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    initialize(0,event.target.value,status,filterName)
    setPage(0);
  };
  
  const handleFilterByName = async(filterName) => {
    setFilterName(filterName);
    setPage(0);
    if(filterName){
      initialize(page,rowsPerPage,status,filterName);
      }else{
      initialize(page,rowsPerPage,status,filterName);
      SetNotFound(false)
      SetLoad(false);
     }
  };
    



  function handleChangeDense(event){
   Setdense(event.target.checked);
  }

  return (
    <Page title="Transaction:  Electricity Bill">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Electricity Subscription Transactions"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.general.app },
            { name: 'List' },
          ]}
        />

        <Card>
        <Tabs
          value={status}
          scrollButtons="auto"
          variant="scrollable"
          allowScrollButtonsMobile
          onChange={(e, value) => {setStatus(value); initialize(page,rowsPerPage,value,filterName); }}
        >
          {ACCOUNT_TABS.map((tab) => (
            <Tab disableRipple key={tab.value} label={capitalCase(tab.label)} value={tab.value} />
          ))}
        </Tabs>
          <PlanToolbar
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table
              size={dense ? 'small' : 'medium'}
              >
                <TransHead
                  order={'asc'}
                  orderBy={'id'}
                  headLabel={TABLE_HEAD}
                  rowCount={userList.length}
                />

              {!load ?   <TableBody>
                 {userList.map((row) => {
                    const { system, customer_name, amount,oldbal, newbal, plan_date, meter_type,  transid, plan_status, meter_number, disco_name, token, charges } = row;
                  
                    return (
                      <TableRow
                        hover
                        key={transid}
                        tabIndex={-1}
                        role="checkbox"
                      >

                        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant="subtitle2" noWrap>
                            {transid}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">{disco_name}</TableCell>
                        <TableCell align="left">{meter_type}</TableCell>
                        <TableCell align="left">{meter_number}</TableCell>
                        <TableCell align="left">{customer_name}</TableCell>
                        <TableCell align="left">₦{fCurrency(amount)}</TableCell>
                        <TableCell align="left">₦{fCurrency(charges)}</TableCell>
                        <TableCell align="left">₦{fCurrency(oldbal)}</TableCell>
                        <TableCell align="left">₦{fCurrency(newbal)}</TableCell>
                        <TableCell align="left">{token}</TableCell>
                        <TableCell align="left">{system}</TableCell>
                        <TableCell align="left">{plan_date}</TableCell>
                        <TableCell align="left">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={(plan_status === 1? 'success' : 'error')}
                          >
                            {sentenceCase((plan_status === 0 && 'processing') || (plan_status === 1 && 'successful') || (plan_status === 2 && 'failed'))}
                          </Label>
                        </TableCell>
                        <TableCell align='left'> 
                        <Button
              variant="contained"
              component={RouterLink}
              to={`${PATH_DASHBOARD.general.invioce}/${transid}/bill`}
            >
              Generate
            </Button>
                        </TableCell >
      
                      </TableRow>
                    );
                  })}
               
                  
                </TableBody> :  <TableRow>
                      <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                      <Typography variant="body2">Loading ...</Typography>
                      </TableCell>
                    </TableRow> }
                {isNotFound && (
                  
                    <TableRow>
                      <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                 
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          
          <FormControlLabel
        control={<Switch checked={dense} onChange={(event) => handleChangeDense(event)} />}
        label="Dense padding" align="left"
      />   
         
         <TablePagination
            rowsPerPageOptions={[5, 10, 25,  100]}
            component="div"
            count={totalPage}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, page) =>  initialize(page,rowsPerPage,status,filterName)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
            
        </Card>
      </Container>
    </Page>
  );
}

// ----------------------------------------------------------------------

